module.exports = [
	{
		"id": 1,
		"name": "Slumber Party Panic",
		"season": 1,
		"airdate": "2010-04-05",
		"summary": "Princess Bumblegum's latest experiment accidentally unleashes an undead horde upon the Candy Kingdom."
	},
	{
		"id": 2,
		"name": "Trouble in Lumpy Space",
		"season": 1,
		"airdate": "2010-04-05",
		"summary": "Jake is bitten by Lumpy Space Princess and begins to transform into a Lumpy being. In order to find a cure, Finn is travels to Lumpy Space."
	},
	{
		"id": 3,
		"name": "Prisoners of Love",
		"season": 1,
		"airdate": "2010-04-12",
		"summary": "After the Ice King kidnaps a large group of princesses, its up to Finn and Jake to free them."
	},
	{
		"id": 4,
		"name": "Tree Trunks",
		"season": 1,
		"airdate": "2010-04-12",
		"summary": "Tree Trunks joins Finn and Jake on an quest, but finds her talents for adventuring leave something to be desired."
	},
	{
		"id": 5,
		"name": "The Enchiridion!",
		"recommended": true,
		"season": 1,
		"airdate": "2010-04-19",
		"summary": "Finn and Jake go on a quest for a magical book that would prove them worthy of being righteous heroes."
	},
	{
		"id": 6,
		"name": "The Jiggler",
		"season": 1,
		"airdate": "2010-04-19",
		"summary": "A jiggly creature attracted by Finn's auto-tuned singing follows Finn and Jake home but soon feels ill effects of separation from its family."
	},
	{
		"id": 7,
		"name": "Ricardio the Heart Guy",
		"season": 1,
		"airdate": "2010-04-26",
		"summary": "After saving Princess Bubblegum from the Ice King yet again she offers them a party, but during the party Finn grows jealous of a suspicious heart-shaped man that is wooing with Princesss Bubblegum and sets out to prove that he's evil."
	},
	{
		"id": 8,
		"name": "Business Time",
		"recommended": true,
		"season": 1,
		"airdate": "2010-04-26",
		"summary": "Finn and Jake fall victim to their own laziness when they delegate their adventuring responsibilities to a group of businessmen thawed from an iceberg."
	},
	{
		"id": 9,
		"name": "My Two Favorite People",
		"recommended": true,
		"season": 1,
		"airdate": "2010-05-03",
		"summary": "Jake feels neglected when his plan to spend time with both Lady Rainicorn and Finn backfires."
	},
	{
		"id": 10,
		"name": "Memories of Boom Boom Mountain",
		"recommended": true,
		"season": 1,
		"airdate": "2010-05-03",
		"summary": "Finn reflects on an upsetting experience in his past and pledges to help everyone in need, but this proves more difficult than imagined."
	},
	{
		"id": 11,
		"name": "Finn the Wizard",
		"season": 1,
		"airdate": "2010-05-10",
		"summary": "Finn and Jake are coaxed by a skeleton man to enroll in a course for free magic powers, but are ultimately tricked into helping stop an asteroid."
	},
	{
		"id": 12,
		"name": "Evicted!",
		"recommended": true,
		"season": 1,
		"airdate": "2010-05-17",
		"summary": "Finn and Jake search the land of Ooo for a new home after Marceline claims the duo's treehouse as her own."
	},
	{
		"id": 13,
		"name": "City of Thieves",
		"season": 1,
		"airdate": "2010-05-24",
		"summary": "Finn and Jake enter the City of Thieves to confront a thief king who has been stealing from little girls."
	},
	{
		"id": 14,
		"name": "The Witch's Garden",
		"season": 1,
		"airdate": "2010-06-07",
		"summary": "Jake loses his enthusiasm for adventure when a witch strips him of his powers for trespassing in her garden."
	},
	{
		"id": 15,
		"name": "What is Life?",
		"recommended": true,
		"season": 1,
		"airdate": "2010-06-14",
		"summary": "Finn builds a pie-throwing robot to seek revenge against Jake, but the machine's conscience is conflicted by the will of the Ice King."
	},
	{
		"id": 16,
		"name": "Ocean of Fear",
		"recommended": true,
		"season": 1,
		"airdate": "2010-06-21",
		"summary": "Jake tries to help Finn overcome his fear of the ocean."
	},
	{
		"id": 17,
		"name": "When Wedding Bells Thaw",
		"season": 1,
		"airdate": "2010-06-28",
		"summary": "The Ice King suppresses his kidnapping urges to wed a suspicious bride and convinces Finn and Jake to throw him a manlorette party, but then realizes he'll have to give up his hobby of kidnapping."
	},
	{
		"id": 18,
		"name": "Dungeon",
		"season": 1,
		"airdate": "2010-07-12",
		"summary": "Finn's headstrong decision to explore a dungeon to find the Crystal Eye in defiance of Jake and Princess Bubblegum's warnings puts him in great danger."
	},
	{
		"id": 19,
		"name": "The Duke",
		"season": 1,
		"airdate": "2010-07-19",
		"summary": "Finn turns Princess Bubblegum green and bald, and faces a moral quandary—whether to confess his mistake and be hated by his friend forever, or let Princess Bubblegum wrongly accuse the Duke of Nuts instead."
	},
	{
		"id": 20,
		"name": "Freak City",
		"recommended": true,
		"season": 1,
		"airdate": "2010-07-26",
		"summary": "After being transformed into a foot by a Magic Man, Finn joins forces with a band of misfits to fix the problem."
	},
	{
		"id": 21,
		"name": "Donny",
		"season": 1,
		"airdate": "2010-08-09",
		"summary": "Finn and Jake help a bullying grass ogre named Donny turn his life around, without realizing the ecological damage they may be causing in the process."
	},
	{
		"id": 22,
		"name": "Henchman",
		"recommended": true,
		"season": 1,
		"airdate": "2010-08-23",
		"summary": "Finn takes the place of Marceline's henchman, but finds it hard to obey her seemingly evil commands."
	},
	{
		"id": 23,
		"name": "Rainy Day Daydream",
		"recommended": true,
		"season": 1,
		"airdate": "2010-09-06",
		"summary": "Stuck inside the treehouse due to a knife storm, Finn and Jake use their imagination to pass the time, but then Finn finds out that whatever Jake imagines becomes real."
	},
	{
		"id": 24,
		"name": "What Have You Done?",
		"season": 1,
		"airdate": "2010-09-13",
		"summary": "Without giving good details, Princess Bubblegum tells Finn and Jake to capture the Ice King as their prisoner, but they struggle to defend their actions when they try to interrogate him."
	},
	{
		"id": 25,
		"name": "Finn Meets His Hero",
		"season": 1,
		"recommended": true,
		"airdate": "2010-09-20",
		"summary": "The great warrior Billy inspires Finn and Jake to practice non-violence, but the duo finds it difficult to resist their old ways."
	},
	{
		"id": 26,
		"name": "The Gut Grinder",
		"recommended": true,
		"season": 1,
		"airdate": "2010-09-27",
		"summary": "When the Soft People's gold has been devoured by a culprit only known as \"The Gut Grinder,\" Finn and Jake team up to track him down."
	},
	{
		"id": 27,
		"name": "It Came from the Nightosphere",
		"recommended": true,
		"season": 2,
		"airdate": "2010-10-11",
		"summary": "Finn summons the Lord of Evil to reconcile with his daughter, Marceline the Vampire Queen, but ends up unleashing him on the unsuspecting land."
	},
	{
		"id": 28,
		"name": "The Eyes",
		"season": 2,
		"airdate": "2010-10-18",
		"summary": "One night, an exhausted Finn and Jake are creeped out by an odd-looking horse that mysteriously appears outside the treehouse and keeps them awake. They try everything they can think of to get rid of the freaky horse, but nothing seems to work."
	},
	{
		"id": 29,
		"name": "Loyalty to the King",
		"season": 2,
		"airdate": "2010-10-25",
		"summary": "There's a new \"Nice King\" in Ooo, and he looks kinda like someone else we know."
	},
	{
		"id": 30,
		"name": "Blood Under the Skin",
		"season": 2,
		"airdate": "2010-11-01",
		"summary": "Finn goes on an embarrassing quest to get armor to fit in with some really cool knights."
	},
	{
		"id": 31,
		"name": "Storytelling",
		"season": 2,
		"airdate": "2010-11-08",
		"summary": "When Jake becomes sick, the only thing that can cure him is a good story, so he asks Finn to go out and find one. The story must have excitement, romance, suspense and, of course, a happy ending. But when nothing interesting happens, Finn tries to make the story happen, accidentally turning the forest animals against each other... and him!"
	},
	{
		"id": 32,
		"name": "Slow Love",
		"season": 2,
		"airdate": "2010-11-15",
		"summary": "A lonely snail lookin' for love literally crashes into the treehouse and asks Finn and Jake for help. Now our heroes must teach this snail how to get a girlfriend before he destroys their home!"
	},
	{
		"id": 33,
		"name": "Power Animal",
		"season": 2,
		"airdate": "2010-11-22",
		"summary": "Finn is kidnapped by a group of gnomes, who want to harness his energy to take over the world. Only Jake can save his best friend... if he can just focus long enough to follow the obvious clues and rescue Finn."
	},
	{
		"id": 34,
		"name": "Crystals Have Power",
		"recommended": true,
		"season": 2,
		"airdate": "2010-11-29",
		"summary": "Jake takes a vow of non-violence which is inconvenient when they're attacked by marauders from the crystal dimension."
	},
	{
		"id": 35,
		"name": "The Other Tarts",
		"season": 2,
		"airdate": "2011-01-03",
		"summary": "Finn and Jake volunteer for a dangerous assignment: carrying rare tarts for a meeting of Ooo royalty."
	},
	{
		"id": 36,
		"name": "To Cut a Woman's Hair",
		"season": 2,
		"airdate": "2011-01-10",
		"summary": "Finn needs to find a princess willing to give up a lock of her hair to save Jake from a balding witch."
	},
	{
		"id": 37,
		"name": "The Chamber of Frozen Blades",
		"season": 2,
		"airdate": "2011-01-17",
		"summary": "In Ninja-mode, Finn and Jake break into Ice King's palace to catch him red-handed."
	},
	{
		"id": 38,
		"name": "Her Parents",
		"recommended": true,
		"season": 2,
		"airdate": "2011-01-24",
		"summary": "Jake pretends to be a rainicorn in order to make Lady's parents like him."
	},
	{
		"id": 39,
		"name": "The Pods",
		"season": 2,
		"airdate": "2011-01-31",
		"summary": "Finn and Jake meet a dying frog-turned gnome knight who is bestowed upon three seeds; two of them are good, one is bad, and he vowed that they will never be planted. Finn accepted the bean quest but he planned to plant the beans so that after the pods grow he could destroy evil."
	},
	{
		"id": 40,
		"name": "The Silent King",
		"season": 2,
		"airdate": "2011-02-07",
		"summary": "Finn and Jake get to live like royalty, but soon find the easy life doesn't suit them. Or at least not Finn."
	},
	{
		"id": 41,
		"name": "The Real You",
		"season": 2,
		"airdate": "2011-02-14",
		"summary": "Finn has to give a speech at Princess Bubblegum's science barbecue and seeks a quick fix to make himself smarter."
	},
	{
		"id": 42,
		"name": "Guardians of Sunshine",
		"season": 2,
		"airdate": "2011-02-21",
		"summary": "Finn and Jake become trapped inside one of BMO's video game creations."
	},
	{
		"id": 43,
		"name": "Death in Bloom",
		"recommended": true,
		"season": 2,
		"airdate": "2011-02-28",
		"summary": "After accidentally killing Princess Bubblegum's beloved plant, Finn and Jake travel to the land of the dead to bring it back to life."
	},
	{
		"id": 44,
		"name": "Susan Strong",
		"recommended": true,
		"season": 2,
		"airdate": "2011-03-07",
		"summary": "Having always believed he is the only human left in the Land of Ooo, Finn believes he has discovered a tribe to primitive humans living underground."
	},
	{
		"id": 45,
		"name": "Mystery Train",
		"season": 2,
		"airdate": "2011-03-14",
		"summary": "While traveling on a train, Finn and Jake find themselves in the middle of a murder mystery."
	},
	{
		"id": 46,
		"name": "Go with Me",
		"season": 2,
		"airdate": "2011-03-28",
		"summary": "Jake and Marceline give Finn conflicting advise on how to ask out Princess Bubblegum."
	},
	{
		"id": 47,
		"name": "Belly of the Beast",
		"season": 2,
		"airdate": "2011-04-04",
		"summary": "Finn and Jake must save a group of clueless, party-minded teddy bears living inside the belly of a monster."
	},
	{
		"id": 48,
		"name": "The Limit",
		"recommended": true,
		"season": 2,
		"airdate": "2011-04-11",
		"summary": "An enormous maze tests the limit of Jake's stretching power."
	},
	{
		"id": 49,
		"name": "Video Makers",
		"recommended": true,
		"season": 2,
		"airdate": "2011-04-18",
		"summary": "Finn and Jake set out to make their own movie, but have conflicting visions of what their movie should be."
	},
	{
		"id": 50,
		"name": "Mortal Folly",
		"recommended": true,
		"season": 2,
		"airdate": "2011-05-02",
		"summary": "The Lich, the greatest form of pure evil in the land of Ooo, is accidentally unleashed. With the highest stakes, Finn and Jake set out on the most serious adventure of their career."
	},
	{
		"id": 51,
		"name": "Mortal Recoil",
		"recommended": true,
		"season": 2,
		"airdate": "2011-05-02",
		"summary": "With the evil Lich seemingly defeated, Finn and Jake are uneasy with their success because of its great cost."
	},
	{
		"id": 52,
		"name": "Heat Signature",
		"season": 2,
		"airdate": "2011-05-09",
		"summary": "Finn and Jake ask Marceline the Vampire Queen to turn them into vampires. However, she isn't interested in transforming her friends and tricks them into thinking she has."
	},
	{
		"id": 53,
		"name": "The Conquest of Cuteness",
		"season": 3,
		"airdate": "2011-07-11",
		"summary": "Finn and Jake's tree house is invaded by Cute King and his army of \"evil\" Cuties who decide to murder Finn and Jake."
	},
	{
		"id": 54,
		"name": "Morituri te Salutamus",
		"season": 3,
		"airdate": "2011-07-18",
		"summary": "Finn and Jake must fight gladiator ghosts in order to gain their freedom from the Fight King."
	},
	{
		"id": 55,
		"name": "Memory of a Memory",
		"recommended": true,
		"season": 3,
		"airdate": "2011-07-25",
		"summary": "Finn and Jake enter Marceline's mind to retrieve a memory of a sleeping spell."
	},
	{
		"id": 56,
		"name": "Hitman",
		"season": 3,
		"airdate": "2011-08-01",
		"summary": "Ice King accidentally hires a hitman to kill Finn & Jake."
	},
	{
		"id": 57,
		"name": "Too Young",
		"recommended": true,
		"season": 3,
		"airdate": "2011-08-08",
		"summary": "The Earl of Lemongrab tries to claim the throne from Princess Bubblegum, who is now 13 years old like Finn."
	},
	{
		"id": 58,
		"name": "The Monster",
		"season": 3,
		"airdate": "2011-08-15",
		"summary": "The king and queen of Lumpy Space ask Finn to track down their daughter and bring her home."
	},
	{
		"id": 59,
		"name": "Still",
		"season": 3,
		"airdate": "2011-08-22",
		"summary": "Finn and Jake are frozen by the Ice King in order to become better \"friends.\""
	},
	{
		"id": 60,
		"name": "Wizard Battle",
		"season": 3,
		"airdate": "2011-08-29",
		"summary": "Finn enters a wizard battle to stop Ice King from winning a kiss from Princess Bubblegum."
	},
	{
		"id": 61,
		"name": "Adventure Time with Fionna and Cake",
		"recommended": true,
		"season": 3,
		"airdate": "2011-09-05",
		"summary": "In this gender-swapped episode, Fionna and Cake fight the evil Ice Queen from marrying Prince Gumball."
	},
	{
		"id": 62,
		"name": "What Was Missing",
		"recommended": true,
		"season": 3,
		"airdate": "2011-09-26",
		"summary": "Finn, Jake, Princess Bubblegum, and Marceline go after an evil door lord by becoming a genuine band to get their stuff back especially everyone's in Land of Ooo."
	},
	{
		"id": 63,
		"name": "Apple Thief",
		"season": 3,
		"airdate": "2011-10-03",
		"summary": "Finn and Jake travel to a seedy part of the Candy Kingdom to track down Tree Trunks' stolen apples."
	},
	{
		"id": 64,
		"name": "The Creeps",
		"recommended": true,
		"season": 3,
		"airdate": "2011-10-17",
		"summary": "Finn and Jake receive an invitation to a masquerade dinner. It turns into a whodunit as guests start to meet their demise."
	},
	{
		"id": 65,
		"name": "From Bad to Worse",
		"season": 3,
		"airdate": "2011-10-24",
		"summary": "A zombie epidemic strikes in Ooo... and it's Princess Bubblegum's fault."
	},
	{
		"id": 66,
		"name": "Beautopia",
		"recommended": true,
		"season": 3,
		"airdate": "2011-11-07",
		"summary": "Susan Strong asks Finn and Jake to help fight off the Lub Glubs and regain her people's home in Beautopia."
	},
	{
		"id": 67,
		"name": "No One Can Hear You",
		"season": 3,
		"airdate": "2011-11-14",
		"summary": "Finn and Jake find themselves alone after the people of the Candy Kingdom vanish."
	},
	{
		"id": 68,
		"name": "Jake vs. Me-Mow",
		"season": 3,
		"airdate": "2011-11-21",
		"summary": "A tiny cat assassin infiltrates Jake's nose, blackmailing him to murder Wildberry Princess."
	},
	{
		"id": 69,
		"name": "Thank You",
		"season": 3,
		"airdate": "2011-11-23",
		"summary": "The Snow Golem visits the border between the Fire Kingdom and the Ice Kingdom and discovers a lost fire wolf that needed the golem's help to get home."
	},
	{
		"id": 70,
		"name": "The New Frontier",
		"season": 3,
		"airdate": "2011-11-28",
		"summary": "Jake dreams about his death, and Finn takes action when events from the dream start to come true."
	},
	{
		"id": 71,
		"name": "Holly Jolly Secrets Part I",
		"recommended": true,
		"season": 3,
		"airdate": "2011-12-05",
		"summary": "In Finn and Jake's holiday special, the heroes come across a video diary of the Ice King's and attempt to decipher its secrets."
	},
	{
		"id": 72,
		"name": "Holly Jolly Secrets Part II",
		"recommended": true,
		"season": 3,
		"airdate": "2011-12-05",
		"summary": "In part two of the holiday special, The Ice King tries to get his video diary back from Finn and Jake."
	},
	{
		"id": 73,
		"name": "Marceline's Closet",
		"season": 3,
		"airdate": "2011-12-12",
		"summary": "Finn and Jake are trapped in Marceline's closet because they thought Marceline would suck their blood."
	},
	{
		"id": 74,
		"name": "Paper Pete",
		"season": 3,
		"airdate": "2012-01-16",
		"summary": "The guardians of the books in the Library seek help from Finn and Jake to save them from the evil Moldos."
	},
	{
		"id": 75,
		"name": "Another Way",
		"season": 3,
		"airdate": "2012-01-23",
		"summary": "Finn is freaked out by Clown Nurses, so he searches for another way to heal his and Jake's broken toes."
	},
	{
		"id": 76,
		"name": "Ghost Princess",
		"season": 3,
		"airdate": "2012-01-30",
		"summary": "Finn and Jake head into Ghost Princess' Cemetery to find the cause of her death, while she finds something greater...and more tragic."
	},
	{
		"id": 77,
		"name": "Dad's Dungeon",
		"recommended": true,
		"season": 3,
		"airdate": "2012-02-06",
		"summary": "Jake's dad presents a strange challenge to the guys when he appears to them in a holographic message."
	},
	{
		"id": 78,
		"name": "Incendium",
		"recommended": true,
		"season": 3,
		"airdate": "2012-02-13",
		"summary": "Trying to help Finn get over his hopeless feelings for Princess Bubblegum, Jake sets out to find a new princess for Finn to go out with."
	},
	{
		"id": 79,
		"name": "Hot to the Touch",
		"recommended": true,
		"season": 4,
		"airdate": "2012-04-02",
		"summary": "Refusing to believe that she is evil, Finn tries to win over his new crush, Flame Princess."
	},
	{
		"id": 80,
		"name": "Five Short Graybles",
		"recommended": true,
		"season": 4,
		"airdate": "2012-04-09",
		"summary": "A series of short stories all centered around the five senses."
	},
	{
		"id": 81,
		"name": "Web Weirdos",
		"season": 4,
		"airdate": "2012-04-16",
		"summary": "When Finn gets trapped in a giant spider web, he ends up playing marriage counselor to a couple of grumpy arachnids."
	},
	{
		"id": 82,
		"name": "Dream of Love",
		"season": 4,
		"airdate": "2012-04-23",
		"summary": "Tree Trunks is courted by an oinking suitor, but much to Jake's dismay, this interferes with her baking habits."
	},
	{
		"id": 83,
		"name": "Return to the Nightosphere",
		"recommended": true,
		"season": 4,
		"airdate": "2012-04-30",
		"summary": "Finn and Jake find themselves imprisoned in the dark realm of the Nightosphere with no memory of how they came to be there."
	},
	{
		"id": 84,
		"name": "Daddy's Little Monster",
		"recommended": true,
		"season": 4,
		"airdate": "2012-04-30",
		"summary": "Continuing their mysterious quest in the Nightosphere, Finn and Jake must rescue their friend Marceline the Vampire Queen."
	},
	{
		"id": 85,
		"name": "In Your Footsteps",
		"recommended": true,
		"season": 4,
		"airdate": "2012-05-07",
		"summary": "Finn and Jake befriend a bear, but what are the bear's intentions?"
	},
	{
		"id": 86,
		"name": "Hug Wolf",
		"season": 4,
		"airdate": "2012-05-14",
		"summary": "Finn discovers a hug wolf and goes through a strange transformation. Becoming a hug wolf himself!"
	},
	{
		"id": 87,
		"name": "Princess Monster Wife",
		"season": 4,
		"airdate": "2012-05-28",
		"summary": "The princesses are strangely losing body parts. So, Finn and Jake investigate."
	},
	{
		"id": 88,
		"name": "Goliad",
		"recommended": true,
		"season": 4,
		"airdate": "2012-06-04",
		"summary": "Realizing her mortality, Princess Bubblegum creates an immortal replacement."
	},
	{
		"id": 89,
		"name": "Beyond this Earthly Realm",
		"season": 4,
		"airdate": "2012-06-11",
		"summary": "When Finn finds a porcelain lamb, it transports him into the spirit world and only the Ice King can help get him out!"
	},
	{
		"id": 90,
		"name": "Gotcha!",
		"season": 4,
		"airdate": "2012-06-18",
		"summary": "In order to do research for her tell-all memoir about men, Lumpy Space Princess goes undercover working for Finn and Jake."
	},
	{
		"id": 91,
		"name": "Princess Cookies",
		"season": 4,
		"airdate": "2012-06-25",
		"summary": "Finn and Jake are called to solve a Candy Kingdom hostage crisis when a rogue cookie takes over."
	},
	{
		"id": 92,
		"name": "Card Wars",
		"season": 4,
		"airdate": "2012-07-16",
		"summary": "Finn and Jake play Card Wars, an epic card game."
	},
	{
		"id": 93,
		"name": "Sons of Mars",
		"recommended": true,
		"season": 4,
		"airdate": "2012-07-23",
		"summary": "Jake becomes a copy of Magic Man after a run-in with him."
	},
	{
		"id": 94,
		"name": "Burning Low",
		"recommended": true,
		"season": 4,
		"airdate": "2012-07-30",
		"summary": "Princess Bubblegum may be jealous when Finn starts hanging out with Flame Princess."
	},
	{
		"id": 95,
		"name": "BMO Noire",
		"season": 4,
		"airdate": "2012-08-06",
		"summary": "BMO tries to find Finn's sock."
	},
	{
		"id": 96,
		"name": "King Worm",
		"recommended": true,
		"season": 4,
		"airdate": "2012-08-13",
		"summary": "All of Ooo appears in Finn's vivid dream."
	},
	{
		"id": 97,
		"name": "Lady & Peebles",
		"season": 4,
		"airdate": "2012-08-20",
		"summary": "Princess Bubblegum and Lady Rainicorn search for a missing Finn and Jake."
	},
	{
		"id": 98,
		"name": "You Made Me",
		"recommended": true,
		"season": 4,
		"airdate": "2012-08-27",
		"summary": "When a creepy sleep-peeping Lemongrab upsets Princess Bubblegum with his creepy ways, Finn and Jake need to tend to some issues in the Outer Realm."
	},
	{
		"id": 99,
		"name": "Who Would Win",
		"season": 4,
		"airdate": "2012-09-03",
		"summary": "Finn and Jake challenge a monster to a fight but end up battling each other."
	},
	{
		"id": 100,
		"name": "Ignition Point",
		"recommended": true,
		"season": 4,
		"airdate": "2012-09-17",
		"summary": "Finn and Jake sneak into the Fire Kingdom and are caught in a family feud."
	},
	{
		"id": 101,
		"name": "The Hard Easy",
		"season": 4,
		"airdate": "2012-10-01",
		"summary": "Mudscamps seek protection from the Mega Frog who's attacking their swamp."
	},
	{
		"id": 102,
		"name": "Reign of Gunters",
		"season": 4,
		"airdate": "2012-10-08",
		"summary": "Gunter and his doppleganger cause chaos in Ooo."
	},
	{
		"id": 103,
		"name": "I Remember You",
		"recommended": true,
		"season": 4,
		"airdate": "2012-10-15",
		"summary": "Ice King and Marceline bond over memories."
	},
	{
		"id": 104,
		"name": "The Lich",
		"recommended": true,
		"season": 4,
		"airdate": "2012-10-22",
		"summary": "Finn has an unclear premonition involving The Lich and sets out to stop the undead creature."
	},
	{
		"id": 105,
		"name": "Finn the Human",
		"recommended": true,
		"season": 5,
		"airdate": "2012-11-12",
		"summary": "After chasing the Lich through the portal, Finn and Jake meet a wishmaster named Prismo."
	},
	{
		"id": 106,
		"name": "Jake the Dog",
		"recommended": true,
		"season": 5,
		"airdate": "2012-11-12",
		"summary": "Jake and Prismo watch from the portal as the Ice King's crown makes Finn more and more powerful."
	},
	{
		"id": 107,
		"name": "Five More Short Graybles",
		"recommended": true,
		"season": 5,
		"airdate": "2012-11-19",
		"summary": "Finn and Jake stick their thumbs in everything; Marceline tries to find her way to Wizard Bill's Music Shop; Ice King gets a new bride."
	},
	{
		"id": 108,
		"name": "Up a Tree",
		"season": 5,
		"airdate": "2012-11-26",
		"summary": "Finn and Jake are playing catch when Finn accidentally tosses their throwing disc into a gigantic tree."
	},
	{
		"id": 109,
		"name": "All the Little People",
		"season": 5,
		"airdate": "2012-12-03",
		"summary": "Magic Man secretly slips Finn a bag filled with miniature versions of Finn and all his friends."
	},
	{
		"id": 110,
		"name": "Jake the Dad",
		"recommended": true,
		"season": 5,
		"airdate": "2013-01-07",
		"summary": "Jake's a daddy, but being a father and keeping his rainicorn pups from killing themselves or each other is a lot harder than he imagined."
	},
	{
		"id": 111,
		"name": "Davey",
		"season": 5,
		"airdate": "2013-01-14",
		"summary": "Finn can't go anywhere without folks stopping to thank him for being a hero."
	},
	{
		"id": 112,
		"name": "Mystery Dungeon",
		"season": 5,
		"airdate": "2013-01-21",
		"summary": "Ice King, NEPTR, Tree Trunks, Shelby and Lemongrab are trapped inside a mysterious dungeon and must work together to free themselves."
	},
	{
		"id": 113,
		"name": "All Your Fault",
		"recommended": true,
		"season": 5,
		"airdate": "2013-01-28",
		"summary": "Princess Bubblegum sends Finn and Jake to investigate a message of distress from the Earls of Lemongrab."
	},
	{
		"id": 114,
		"name": "Little Dude",
		"season": 5,
		"airdate": "2013-02-04",
		"summary": "While Finn & Jake go swimming, Finn's hat magically comes to life!"
	},
	{
		"id": 115,
		"name": "Bad Little Boy",
		"recommended": true,
		"season": 5,
		"airdate": "2013-02-18",
		"summary": "The princesses are sick and tired of Ice King's crazy Fionna & Cake stories, so Marceline stops by the Ice Kingdom to show him how it's done."
	},
	{
		"id": 116,
		"name": "Vault of Bones",
		"recommended": true,
		"season": 5,
		"airdate": "2013-02-25",
		"summary": "Finn's worried that Flame Princess still has evil tendencies in her and wants to shift her alignment to good."
	},
	{
		"id": 117,
		"name": "The Great Bird Man",
		"season": 5,
		"airdate": "2013-03-04",
		"summary": "Finn and Jake get lost in the badlands and are saved by Xergiok, ex-Goblin King who now lives in cave."
	},
	{
		"id": 118,
		"name": "Simon & Marcy",
		"recommended": true,
		"season": 5,
		"airdate": "2013-03-25",
		"summary": "A look at what Ice King and Marceline were like 996 years ago."
	},
	{
		"id": 119,
		"name": "A Glitch is a Glitch",
		"season": 5,
		"airdate": "2013-04-01",
		"summary": "Ice King creates a computer virus to delete everybody except him and Princess Bubblegum."
	},
	{
		"id": 120,
		"name": "Puhoy",
		"recommended": true,
		"season": 5,
		"airdate": "2013-04-08",
		"summary": "Stuck inside the treehouse during a sword storm, Jake builds a pillow fort while Finn goes to a different world."
	},
	{
		"id": 121,
		"name": "BMO Lost",
		"season": 5,
		"airdate": "2013-04-15",
		"summary": "BMO gets snatched away by a giant eagle and must find his way home."
	},
	{
		"id": 122,
		"name": "Princess Potluck",
		"season": 5,
		"airdate": "2013-04-22",
		"summary": "Ice King gets super jealous when he finds out that he wasn't invited to the Princess Potluck."
	},
	{
		"id": 123,
		"name": "James Baxter the Horse",
		"season": 5,
		"airdate": "2013-05-06",
		"summary": "Finn and Jake meet a horse with the power to make sad people happy."
	},
	{
		"id": 124,
		"name": "Shh!",
		"season": 5,
		"airdate": "2013-05-13",
		"summary": "Finn and Jake hold a contest to see who can last longer without talking."
	},
	{
		"id": 125,
		"name": "The Suitor",
		"recommended": true,
		"season": 5,
		"airdate": "2013-05-20",
		"summary": "Peppermint Butler thinks Princess Bubblegum is spending too much time in her lab and decides she needs a suitor."
	},
	{
		"id": 126,
		"name": "The Party's Over, Isla de Señorita",
		"season": 5,
		"airdate": "2013-05-27",
		"summary": "His kidnapping scheme foiled again for like the millionth time, Ice King decides he's had enough."
	},
	{
		"id": 127,
		"name": "One Last Job",
		"recommended": true,
		"season": 5,
		"airdate": "2013-06-10",
		"summary": "Jake Jr. gets mixed up with some bad eggs and Jake has to reunite with his old gang for one last job to save him."
	},
	{
		"id": 128,
		"name": "Another 5 Short Graybles",
		"recommended": true,
		"season": 5,
		"airdate": "2013-06-17",
		"summary": "Why are Finn and Jake building a time machine? Can Princess Bubblegum help Cinnamon Bun conquer his fear of the dark?"
	},
	{
		"id": 129,
		"name": "Candy Streets",
		"season": 5,
		"airdate": "2013-06-24",
		"summary": "LSP is robbed and faints before she can tell Finn and Jake who robbed her."
	},
	{
		"id": 130,
		"name": "Wizards Only, Fools",
		"season": 5,
		"airdate": "2013-07-01",
		"summary": "Princess Bubblegum believes magic is nothing but a bunch of hooey, but when Starchy gets sick and asks her to use magic to cure him, she asks Finn and Jake to help her sneak into Wizard City to get a cold spell."
	},
	{
		"id": 131,
		"name": "Jake Suit",
		"season": 5,
		"airdate": "2013-07-15",
		"summary": "Jake is sick and tired of Finn using his body as a suit of armor, so he convinces Finn to trade places to show him how much it really stinks."
	},
	{
		"id": 132,
		"name": "Be More",
		"recommended": true,
		"season": 5,
		"airdate": "2013-07-22",
		"summary": "Finn and Jake disguise themselves as MOs in order to infiltrate the MO factory in hopes of saving BMO from malfunctioning."
	},
	{
		"id": 133,
		"name": "Sky Witch",
		"recommended": true,
		"season": 5,
		"airdate": "2013-07-29",
		"summary": "Marceline is on a top-secret mission tracking Maja the Sky Witch. But when she loses the witch's trail, Marceline turns to Princess Bubblegum for help."
	},
	{
		"id": 134,
		"name": "Frost & Fire",
		"recommended": true,
		"season": 5,
		"airdate": "2013-08-05",
		"summary": "After Flame Princess battles Ice King, Finn has an exciting dream. But when it abruptly ends, Finn must get FP and IK to fight again to find out how it ends."
	},
	{
		"id": 135,
		"name": "Too Old",
		"recommended": true,
		"season": 5,
		"airdate": "2013-08-12",
		"summary": "Finn, Jake and PB discover a talented mutant named Lemonsqueak at The Pageant of Mutants. Now they must find a way to free him from the lemongrabs."
	},
	{
		"id": 136,
		"name": "Earth & Water",
		"recommended": true,
		"season": 5,
		"airdate": "2013-09-02",
		"summary": "Princess Bubblegum subjects Flame Princess to a series of tests to gauge FP's fiery tendencies. But when there's an emergency at the treehouse, and PB leaves Cinnamon Bun to watch Flame Princess, her experiment might literally backfire in her face."
	},
	{
		"id": 137,
		"name": "Time Sandwich",
		"season": 5,
		"airdate": "2013-09-09",
		"summary": "Jake crafts the most delicious sandwich ever, but when Magic Man steals it, Finn must defy the laws of space and time to win back Jake's creation."
	},
	{
		"id": 138,
		"name": "The Vault",
		"recommended": true,
		"season": 5,
		"airdate": "2013-09-16",
		"summary": "When Finn starts sleepwalking and dreaming about the Green Lady he filed away in his memory vault, Jake and BMO help him tap into his repressed memories to uncover a secret past. Who is the Green Lady? And how is she connected to Finn?"
	},
	{
		"id": 139,
		"name": "Love Games",
		"season": 5,
		"airdate": "2013-09-23",
		"summary": "Slime Princess needs a husband or else she'll lose the Slime Kingdom to her obnoxious sis. Finn steps in to save the day, but first they will need to win a series of Love Games to prove to Slime Princess's dad that they are really in love. This is definitely NOT what Finn signed up for!"
	},
	{
		"id": 140,
		"name": "Dungeon Train",
		"season": 5,
		"airdate": "2013-09-30",
		"summary": "All aboard! Finn and Jake discover a train where every car is a dungeon filled with a new foe for Finn to fight. Jake quickly gets bored and wants to leave, but Finn is having the BEST time and doesn't want to leave... ever!"
	},
	{
		"id": 141,
		"name": "The Box Prince",
		"season": 5,
		"airdate": "2013-10-07",
		"summary": "Finn meets the Box Prince (a cat with a box on its back) and discovers the Box Kingdom has been taken over by an imposter. Now, Finn must help the real Box Prince reclaim his rightful throne."
	},
	{
		"id": 142,
		"name": "Red Starved",
		"recommended": true,
		"season": 5,
		"airdate": "2013-10-14",
		"summary": "Finn, Jake and Marceline are trapped in an underground cavern with no red in sight. If Marceline doesn't feed, like ASAP, she will turn into a vampiric beast and suck out all of Jake's blood! So, Finn heads off to explore the cave and find something red to satiate her until they can be rescued. But time is running out!"
	},
	{
		"id": 143,
		"name": "We Fixed a Truck",
		"season": 5,
		"airdate": "2013-10-21",
		"summary": "Finn finds an old truck, and Jake calls Banana Man to help with the repairs. But when BMO stays up all night working on the truck, he hears on a spooky radio talk show that Princess Bubblegum is a reptilian replicant. Is it just another one of Starchy's crazy conspiracy theories, or a fact?"
	},
	{
		"id": 144,
		"name": "Play Date",
		"recommended": true,
		"season": 5,
		"airdate": "2013-11-04",
		"summary": "Sick and tired of babysitting Ice King while the Ice Kingdom is being rebuilt, Finn and Jake call up an old friend to hang out with their annoying houseguest: Abracadaniel. But when Ice King and his new BFF accidentally unleash the demon Kee-Oth, Finn and Jake have to clean up their mess."
	},
	{
		"id": 145,
		"name": "The Pit",
		"recommended": true,
		"season": 5,
		"airdate": "2013-11-18",
		"summary": "Kee-Oth the Blood Demon has kidnapped Jake, taken him back to his dimension and thrown him in a pit. If Finn wants to rescue his friend, he's going to need Lady Rainicorn's help... and a videotape that will reveal how to open the portal to Kee-Oth's messed-up dimension."
	},
	{
		"id": 146,
		"name": "James",
		"recommended": true,
		"season": 5,
		"airdate": "2013-11-25",
		"summary": "Finn & Jake are excited when Princess Bubblegum invites them to help her collect samples in the Desert of Wonders. But when their vessel is attacked by nasty goo monsters, Finn & Jake start to think the mission has been sabotaged by PB's robot helper James."
	},
	{
		"id": 147,
		"name": "Root Beer Guy",
		"recommended": true,
		"season": 5,
		"airdate": "2013-12-02",
		"summary": "Root Beer Guy works a boring job during the day and tries to write mystery stories at night. But his life is about to change when he witnesses Finn & Jake kidnapping Princess Bubblegum! There's only one problem: no one believes Root Beer Guy..."
	},
	{
		"id": 148,
		"name": "Apple Wedding",
		"season": 5,
		"airdate": "2014-01-13",
		"summary": "You are cordially invited to the Wedding of the Year! But who will be united in matrimony?"
	},
	{
		"id": 149,
		"name": "Blade of Grass",
		"recommended": true,
		"season": 5,
		"airdate": "2014-01-20",
		"summary": "Finn and Jake decide it's time for Finn to get a new sword. Finn reluctantly buys a grass sword from a mysterious old man, but the sword turns out to be cursed! And unfortunately for our hero, all sales are final."
	},
	{
		"id": 150,
		"name": "Rattleballs",
		"recommended": true,
		"season": 5,
		"airdate": "2014-01-27",
		"summary": "Finn practices his sword fighting skills at the candy junkyard, where he meets an old gumball robot named Rattleballs. To Finn's shock, he finds out he's NOT the master swordsman he thinks he is. What the what?! Finn begs Rattleballs to train him, but he soon discovers his mentor's deep, dark secret... a secret that will ultimately test Finn's loyalty to Princess Bubblegum."
	},
	{
		"id": 151,
		"name": "The Red Throne",
		"recommended": true,
		"season": 5,
		"airdate": "2014-02-10",
		"summary": "When Flame King breaks out of his prison and takes over the Flame Kingdom again, Flame Princess turns to the one person she believes she can trust... Finn! But will Finn be able to put his feelings for Flame Princess aside long enough to help her reclaim her throne?"
	},
	{
		"id": 152,
		"name": "Betty",
		"recommended": true,
		"season": 5,
		"airdate": "2014-02-24",
		"summary": "In Wizard City, a magic spell backfires and turns Ice King back into Simon. Now with Finn, Jake and Marceline's help, Simon finds a way to bring his beloved Betty back. Finally reunited with the love of his life, everything is great! There's just one catch...without his magic crown, Simon will die."
	},
	{
		"id": 153,
		"name": "Bad Timing",
		"season": 5,
		"airdate": "2014-03-03",
		"summary": "Love is in the air when Lumpy Space Princess reconnects with an old classmate, but will her jealousy get in the way of finding true love?"
	},
	{
		"id": 154,
		"name": "Lemonhope Part I",
		"recommended": true,
		"season": 5,
		"airdate": "2014-03-10",
		"summary": "Tired of all of Princess Bubblegum's talk about \"responsibility,\" Lemonhope yearns for true freedom. So he sets off on the greatest adventure of his lemony life."
	},
	{
		"id": 155,
		"name": "Lemonhope Part II",
		"recommended": true,
		"season": 5,
		"airdate": "2014-03-10",
		"summary": "Though Lemonhope finds refuge from the desert with monster hunter Phlannel Boxingday, he might not be able to escape the ghosts of his past."
	},
	{
		"id": 156,
		"name": "Billy's Bucket List",
		"recommended": true,
		"season": 5,
		"airdate": "2014-03-17",
		"summary": "Finn finds the hero Billy's bucket list and ecides to complete the unfiished items as a final tribute."
	},
	{
		"id": 157,
		"name": "Wake Up",
		"recommended": true,
		"season": 6,
		"airdate": "2014-04-21",
		"summary": "In order to find Finn's father, Finn and Jame must commit a cosmic crime...unless the Lich beats them to it."
	},
	{
		"id": 158,
		"name": "Escape from the Citadel",
		"recommended": true,
		"season": 6,
		"airdate": "2014-04-21",
		"summary": "Finn and Jake follow the Lich of the Citadel, where Finn meets his long \nlost dad. But just how far does the apple fall from the tree?"
	},
	{
		"id": 159,
		"name": "James II",
		"recommended": true,
		"season": 6,
		"airdate": "2014-04-28",
		"summary": "Finn and Jake discover that Clone James has been faking his own death to collect medals. But there are 25 Jameses running amok!"
	},
	{
		"id": 160,
		"name": "The Tower",
		"recommended": true,
		"season": 6,
		"airdate": "2014-05-05",
		"summary": "Finn doesn't like any of the new arms the princesses give him, so he builts a tower into space to find his dad and get his old arm back."
	},
	{
		"id": 161,
		"name": "Sad Face",
		"season": 6,
		"airdate": "2014-05-12",
		"summary": "Once a month, while Jake's asleep, his tail stretches out of the treehouse to go work as a clown in a travelling bug circus."
	},
	{
		"id": 162,
		"name": "Breezy",
		"recommended": true,
		"season": 6,
		"airdate": "2014-06-05",
		"summary": "With a friendly bee named \"Breezy\" as his wingman, Finn decides to get back into the dating game."
	},
	{
		"id": 163,
		"name": "Food Chain",
		"season": 6,
		"airdate": "2014-06-12",
		"summary": "On a field trip to the Candy Kingdom Museum of Natural History, Finn and\n Jake learn about the Food chain by becoming the food chain!"
	},
	{
		"id": 164,
		"name": "Furniture & Meat",
		"season": 6,
		"airdate": "2014-06-19",
		"summary": "Big money problems send Finn and Jake to Wildberry Kingdom."
	},
	{
		"id": 165,
		"name": "The Prince Who Wanted Everything",
		"season": 6,
		"airdate": "2014-06-26",
		"summary": "The beautiful and sensitive Lumpy Space Prince flees his cruel parents to start a new life."
	},
	{
		"id": 166,
		"name": "Something Big",
		"recommended": true,
		"season": 6,
		"airdate": "2014-07-03",
		"summary": "Princess Bubblegum must rally her forces when the Candy Kingdom is rocked by a massive assault."
	},
	{
		"id": 167,
		"name": "Little Brother",
		"season": 6,
		"airdate": "2014-07-10",
		"summary": "Shelby is thrust into a new role after a party-related accident."
	},
	{
		"id": 168,
		"name": "Ocarina",
		"recommended": true,
		"season": 6,
		"airdate": "2014-07-17",
		"summary": "Fed up with Jake's antics, his son Kim Kil Whan takes action."
	},
	{
		"id": 169,
		"name": "Thanks for the Crabapples, Giuseppe",
		"season": 6,
		"airdate": "2014-07-24",
		"summary": "Ice King and a band of misfit wizards go on a mystical road trip."
	},
	{
		"id": 170,
		"name": "Princess Day",
		"season": 6,
		"airdate": "2014-07-31",
		"summary": "It's Princess Day in Ooo! You know what that means? Yep, LSP and Marceline team up to prank Breakfast Princess!"
	},
	{
		"id": 171,
		"name": "Nemesis",
		"season": 6,
		"airdate": "2014-08-07",
		"summary": "A shadowy figure named Peace Master targets the Candy Kingdom elite."
	},
	{
		"id": 172,
		"name": "Joshua & Margaret Investigations",
		"recommended": true,
		"season": 6,
		"airdate": "2014-08-14",
		"summary": "Finn and Jake's parents hunt an unearthly menace in the woods."
	},
	{
		"id": 173,
		"name": "Ghost Fly",
		"season": 6,
		"airdate": "2014-10-28",
		"summary": "Jake and the tree house are haunted by a vengeful spectre."
	},
	{
		"id": 174,
		"name": "Everything's Jake",
		"season": 6,
		"airdate": "2014-11-24",
		"summary": "Jake finds himself transported to a world both alien and familiar."
	},
	{
		"id": 175,
		"name": "Is That You?",
		"recommended": true,
		"season": 6,
		"airdate": "2014-11-25",
		"summary": "After a memorial for a fallen ally, Jake starts acting very strange."
	},
	{
		"id": 176,
		"name": "Jake the Brick",
		"recommended": true,
		"season": 6,
		"airdate": "2014-11-26",
		"summary": "Jake sets out to fulfill a bizarre lifelong ambition."
	},
	{
		"id": 177,
		"name": "Dentist",
		"season": 6,
		"airdate": "2014-11-28",
		"summary": "Finn's aching tooth leaves him with no othe roption but to go to the dentist."
	},
	{
		"id": 178,
		"name": "The Cooler",
		"recommended": true,
		"season": 6,
		"airdate": "2014-12-04",
		"summary": "When the Fire Kingdom is struck by a natural disaster, Flame Princess turns to an unlikely ally."
	},
	{
		"id": 179,
		"name": "The Pajama Wars",
		"season": 6,
		"airdate": "2015-01-08",
		"summary": "A Candy Kingdom slumber party devolves into panic when Finn and Princess Bubblegum vanish."
	},
	{
		"id": 180,
		"name": "Evergreen",
		"recommended": true,
		"season": 6,
		"airdate": "2015-01-15",
		"summary": "In a distant age, the wizard Evergreen quests to save the world."
	},
	{
		"id": 181,
		"name": "Astral Plane",
		"recommended": true,
		"season": 6,
		"airdate": "2015-01-22",
		"summary": "Finn has an out-of-body experience that takes him all over Ooo and beyond."
	},
	{
		"id": 182,
		"name": "Gold Stars",
		"recommended": true,
		"season": 6,
		"airdate": "2015-01-29",
		"summary": "Tree Trunks and Mr. Pig's child, Sweet P, runs into trouble on his first day of school."
	},
	{
		"id": 183,
		"name": "The Visitor",
		"recommended": true,
		"season": 6,
		"airdate": "2015-02-05",
		"summary": "A vision leads Finn to a friendly civilization and a mysterious crash site."
	},
	{
		"id": 184,
		"name": "The Mountain",
		"recommended": true,
		"season": 6,
		"airdate": "2015-02-12",
		"summary": "Lemongrab and Finn go on a journey of discovery through the Mountain of Matthew."
	},
	{
		"id": 185,
		"name": "Dark Purple",
		"recommended": true,
		"season": 6,
		"airdate": "2015-02-19",
		"summary": "Finn and his magical dog Jake get into outlandish adventures in the land of Ooo."
	},
	{
		"id": 186,
		"name": "The Diary",
		"season": 6,
		"airdate": "2015-02-26",
		"summary": "Jake's son TV discovers a lost diary and sets out to solve a decades-old mystery."
	},
	{
		"id": 187,
		"name": "Walnuts & Rain",
		"season": 6,
		"airdate": "2015-03-05",
		"summary": "Two different fates await Finn and Jake."
	},
	{
		"id": 188,
		"name": "Friends Forever",
		"season": 6,
		"airdate": "2015-04-16",
		"summary": "Ice King plots to form a perfect circle of confidants."
	},
	{
		"id": 189,
		"name": "Jermaine",
		"recommended": true,
		"season": 6,
		"airdate": "2015-04-23",
		"summary": "After a chilling dream encounter, Finn & Jake are determined to reconnect with their reclusive brother."
	},
	{
		"id": 190,
		"name": "Chips & Ice Cream",
		"season": 6,
		"airdate": "2015-04-30",
		"summary": "BMO's favorite entertainers unexpectedly find a new home at the tree house."
	},
	{
		"id": 191,
		"name": "Graybles 1000+",
		"recommended": true,
		"season": 6,
		"airdate": "2015-05-07",
		"summary": "Marooned on an alien world, Cuber must rely on his bag of Graybles to survive."
	},
	{
		"id": 192,
		"name": "Hoots",
		"recommended": true,
		"season": 6,
		"airdate": "2015-05-14",
		"summary": "A charismatic stranger in Finn's dream leads Cosmic Owl to shirk his duties."
	},
	{
		"id": 193,
		"name": "Water Park Prank",
		"season": 6,
		"airdate": "2015-05-21",
		"summary": "After rescuing Princess Orangutan from Daddy-sad-heads, Finn & Jake head to a post-apocalyptic water park for a day of fun."
	},
	{
		"id": 194,
		"name": "You Forgot Your Floaties",
		"recommended": true,
		"season": 6,
		"airdate": "2015-06-01",
		"summary": "Finn & Jake storm Magic Man's house to rescue his new apprentice."
	},
	{
		"id": 195,
		"name": "Be Sweet",
		"recommended": true,
		"season": 6,
		"airdate": "2015-06-02",
		"summary": "A fed up Lumpy Space Princess leaves the woods for a glamorous career in babysitting."
	},
	{
		"id": 196,
		"name": "Orgalorg",
		"recommended": true,
		"season": 6,
		"airdate": "2015-06-03",
		"summary": "After a walrus race accident, Gunther starts to experience strange visions."
	},
	{
		"id": 197,
		"name": "On the Lam",
		"season": 6,
		"airdate": "2015-06-04",
		"summary": "Finn's dad Martin the Human fights for freedom on a strange new planet!"
	},
	{
		"id": 198,
		"name": "Hot Diggity Doom",
		"recommended": true,
		"season": 6,
		"airdate": "2015-06-05",
		"summary": "It's election day in the Candy Kingdom but Princess Bubblegum's attention is diverted by a mysterious presence in the sky."
	},
	{
		"id": 199,
		"name": "The Comet",
		"recommended": true,
		"season": 6,
		"airdate": "2015-06-05",
		"summary": "Finn, Jake and Orgalorg converge with the comet and meet their destiny."
	},
	{
		"id": 200,
		"name": "Bonnie & Neddy",
		"recommended": true,
		"season": 7,
		"airdate": "2015-11-02",
		"summary": "Jake and Finn are sleuthing under the order of Candy Kingdom's new princess when they discover one of the land's greatest secrets."
	},
	{
		"id": 201,
		"name": "Varmints",
		"recommended": true,
		"season": 7,
		"airdate": "2015-11-03",
		"summary": "When something threatens her homestead's citizens, Bubblegum turns to Marceline for help."
	},
	{
		"id": 202,
		"name": "Cherry Cream Soda",
		"season": 7,
		"airdate": "2015-11-04",
		"summary": "Cherry Cream Soda's life falls flat with the arrival of a visitor."
	},
	{
		"id": 203,
		"name": "Mama Said",
		"season": 7,
		"airdate": "2015-11-05",
		"summary": "Finn and Jake's loyalty is questioned when King of Ooo sends the duo on a mission to catch flying mushrooms."
	},
	{
		"id": 204,
		"name": "Football",
		"season": 7,
		"airdate": "2015-11-06",
		"summary": "BMO and Football make a deal but one them can't hold their end of the bargain."
	},
	{
		"id": 205,
		"name": "Marceline the Vampire Queen",
		"recommended": true,
		"season": 7,
		"airdate": "2015-11-16",
		"summary": "Finn & Jake hunt for a shadowy predator and Marceline asks Princess Bubblegum for a huge favor."
	},
	{
		"id": 206,
		"name": "Everything Stays",
		"recommended": true,
		"season": 7,
		"airdate": "2015-11-16",
		"summary": "As the sun rises on her last day, Marceline recalls her long extraordinary life."
	},
	{
		"id": 207,
		"name": "Vamps About",
		"recommended": true,
		"season": 7,
		"airdate": "2015-11-17",
		"summary": "Five foes from Marceline's past come back to cause trouble for the Land of Ooo."
	},
	{
		"id": 208,
		"name": "Empress Eyes",
		"recommended": true,
		"season": 7,
		"airdate": "2015-11-17",
		"summary": "When one of her oldest adversaries targets the Ice Kingdom, Marceline rushes to Simon's rescue."
	},
	{
		"id": 209,
		"name": "May I Come In?",
		"recommended": true,
		"season": 7,
		"airdate": "2015-11-18",
		"summary": "Finn, Jake, Marceline, and PB set out to hunt down the Vamps. But who is hunting them?"
	},
	{
		"id": 210,
		"name": "Take Her Back",
		"recommended": true,
		"season": 7,
		"airdate": "2015-11-18",
		"summary": "While Princess Bubblegum searches for a cure for Marceline, Finn & Jake take on one of the Vamps themselves."
	},
	{
		"id": 211,
		"name": "Checkmate",
		"recommended": true,
		"season": 7,
		"airdate": "2015-11-19",
		"summary": "On the eve of battle, Marceline's archenemy comes to her with a strange proposal."
	},
	{
		"id": 212,
		"name": "The Dark Cloud",
		"recommended": true,
		"season": 7,
		"airdate": "2015-11-19",
		"summary": "The final confrontation! Who will survive?"
	},
	{
		"id": 213,
		"name": "The More You Moe, The Moe You Know: Part I",
		"recommended": true,
		"season": 7,
		"airdate": "2015-12-03",
		"summary": "\"Moe\" visits the tree house with a special birthday mission for BMO. While BMO's mission stands on the brink of disaster, Finn and Jake host \"Moe\"."
	},
	{
		"id": 214,
		"name": "The More You Moe, The Moe You Know: Part II",
		"recommended": true,
		"season": 7,
		"airdate": "2015-12-03",
		"summary": "\"Moe\" is actually revealed to be AMO, who attempts to destroy BMO and steal Finn and Jake for itself."
	},
	{
		"id": 215,
		"name": "Summer Showers",
		"season": 7,
		"airdate": "2016-01-07",
		"summary": "Jake's daughter Viola is up for a role in a play by a hot new director?Lumpy Space Princess."
	},
	{
		"id": 216,
		"name": "Angel Face",
		"season": 7,
		"airdate": "2016-01-11",
		"summary": "BMO convinces his friends to join him in a live action cowboy role-playing game."
	},
	{
		"id": 217,
		"name": "President Porpoise is Missing!",
		"season": 7,
		"airdate": "2016-01-12",
		"summary": "Jake and Finn try to find President Porpoise before Vice President Blowfish takes over."
	},
	{
		"id": 218,
		"name": "Blank-Eyed Girl",
		"season": 7,
		"airdate": "2016-01-13",
		"summary": "One very spooky night, Finn and Jake come face-to-face with an urban myth."
	},
	{
		"id": 219,
		"name": "Bad Jubies",
		"season": 7,
		"airdate": "2016-01-14",
		"summary": "Finn, LSP and BMO build a bunk to protect themselves from a storm; Jake has his own ideas."
	},
	{
		"id": 220,
		"name": "A King's Ransom",
		"recommended": true,
		"season": 7,
		"airdate": "2016-01-15",
		"summary": "Ice King suffers a heartbreaking loss and it's up to Finn and Jake to find the culprit."
	},
	{
		"id": 221,
		"name": "Scamps",
		"season": 7,
		"airdate": "2016-01-21",
		"summary": "Finn takes a group of at-risk Candy Kingdom youth on a camping trip they'll never forget."
	},
	{
		"id": 222,
		"name": "Crossover",
		"recommended": true,
		"season": 7,
		"airdate": "2016-01-28",
		"summary": "Prismo needs Finn and Jake's help to stop a catastrophic event from happening somewhere in the multiverse."
	},
	{
		"id": 223,
		"name": "Hall of Egress",
		"season": 7,
		"airdate": "2016-03-05",
		"summary": "Trapped and alone, Finn must unravel the riddle of the weird cave with no exit."
	},
	{
		"id": 224,
		"name": "Flute Spell",
		"recommended": true,
		"season": 7,
		"airdate": "2016-03-12",
		"summary": "Jake learns that Finn's been having clandestine meetings with a powerful wizard. But what are they up to?"
	},
	{
		"id": 225,
		"name": "The Thin Yellow Line",
		"recommended": true,
		"season": 7,
		"airdate": "2016-03-19",
		"summary": "Finn and Jake infiltrte the Banana Guard ranks and stumble upon a conspiracy."
	},
	{
		"id": 226,
		"name": "Broke His Crown",
		"recommended": true,
		"season": 7,
		"airdate": "2016-03-26",
		"summary": "When Ice King's magic crown goes haywire, marceline and Princess Bubblegum resort to extreme measures to help him."
	},
	{
		"id": 227,
		"name": "Don't Look",
		"recommended": true,
		"season": 7,
		"airdate": "2016-04-02",
		"summary": "At the top of Dead Mountain, Finn discovers a treasure that comes with a terrible price."
	},
	{
		"id": 228,
		"name": "Beyond the Grotto",
		"season": 7,
		"airdate": "2016-04-09",
		"summary": "Finn and Jake follow sea-lion into the pound and discover a mysterious dimension."
	},
	{
		"id": 229,
		"name": "Lady Rainicorn and the Crystal Dimension",
		"season": 7,
		"airdate": "2016-04-16",
		"summary": "Jake's son TV finds a hidden box and draws the attention of a super cool Rainicorn named Lee."
	},
	{
		"id": 230,
		"name": "I Am a Sword",
		"recommended": true,
		"season": 7,
		"airdate": "2016-04-23",
		"summary": "Finn starts having guilt nightmares about his missing Finn Sword...but are the nightmares real?"
	},
	{
		"id": 231,
		"name": "Bun Bun",
		"season": 7,
		"airdate": "2016-05-05",
		"summary": "Finn brings a special delivery for Cinnamon Bun."
	},
	{
		"id": 232,
		"name": "Normal Man",
		"season": 7,
		"airdate": "2016-05-12",
		"summary": "Stripped of his magic powers, Normal Man enlists Finn and Jake's help to rescue his brother Glob."
	},
	{
		"id": 233,
		"name": "Elemental",
		"recommended": true,
		"season": 7,
		"airdate": "2016-05-19",
		"summary": "Ice King discovers something buried deep beneath the Ice Kingdom that could change Ooo forever."
	},
	{
		"id": 234,
		"name": "Five Short Tables",
		"season": 7,
		"airdate": "2016-05-26",
		"summary": "Fionna and Cake go on a cooking adventure to push Cake's are to an all-new-level."
	},
	{
		"id": 235,
		"name": "The Music Hole",
		"recommended": true,
		"season": 7,
		"airdate": "2016-06-23",
		"summary": "While judging the hugest Battle of the Bands in the history of Ooo, Finn hears a mysterious new song."
	},
	{
		"id": 236,
		"name": "Daddy-Daughter Card Wars",
		"season": 7,
		"airdate": "2016-07-07",
		"summary": "To put his embarrassing past behind him, Jake needs his daughter Charlie's help to win an underground Card Wars tourney."
	},
	{
		"id": 237,
		"name": "PreBoot",
		"recommended": true,
		"season": 7,
		"airdate": "2016-11-19",
		"summary": "During an excavation, Finn, Jake and Susan encounter a mysterious stranger who may hold the key to the past.\n "
	},
	{
		"id": 238,
		"name": "ReBoot",
		"recommended": true,
		"season": 7,
		"airdate": "2016-11-19",
		"summary": "Finn and Jake take on one of the fiercest enemies they've faced when a powerful ally goes rogue.\n "
	},
	{
		"id": 239,
		"name": "Two Swords",
		"recommended": true,
		"season": 8,
		"airdate": "2017-01-23",
		"summary": "Finn and Jake contend with a mysterious, but familiar, new being."
	},
	{
		"id": 240,
		"name": "Do No Harm",
		"recommended": true,
		"season": 8,
		"airdate": "2017-01-23",
		"summary": "Finn makes amends at the Candy Hospital while Jake tries to connect with their unexpected houseguest."
	},
	{
		"id": 241,
		"name": "Wheels",
		"season": 8,
		"airdate": "2017-01-24",
		"summary": "Kim Kil Whan is worried about his daughter's future and asks Jake for some parental advice."
	},
	{
		"id": 242,
		"name": "High Strangeness",
		"season": 8,
		"airdate": "2017-01-25",
		"summary": "An otherworldly encounter puts Tree Trunks on the trail of a conspiracy in the Candy Kingdom."
	},
	{
		"id": 243,
		"name": "Horse and Ball",
		"season": 8,
		"airdate": "2017-01-26",
		"summary": "When disaster befalls James Baxter, it's up to Finn and Jake to help him pick up the pieces."
	},
	{
		"id": 244,
		"name": "Jelly Beans Have Power",
		"recommended": true,
		"season": 8,
		"airdate": "2017-01-27",
		"summary": "Princess Bubblegum's scientific mind must wrestle with her Elemental magic potential when she's faced with a Crystal Entity."
	},
	{
		"id": 245,
		"name": "The Invitation",
		"recommended": true,
		"season": 8,
		"airdate": "2017-01-30",
		"summary": "A mysterious craft invades Ooo and Finn believes it may hold the secrets to his past."
	},
	{
		"id": 246,
		"name": "Whipple the Happy Dragon",
		"recommended": true,
		"season": 8,
		"airdate": "2017-01-30",
		"summary": "Finn, Jake, and Susan set sail on a ocean voyage full of wonders and danger."
	},
	{
		"id": 247,
		"name": "Mysterious Island",
		"recommended": true,
		"season": 8,
		"airdate": "2017-01-31",
		"summary": "After waking up alone and shipwrecked, Finn investigates a bizarre island in search of his friends."
	},
	{
		"id": 248,
		"name": "Imaginary Resources",
		"recommended": true,
		"season": 8,
		"airdate": "2017-01-31",
		"summary": "Finn and Jake travel to a land where reality has been redesigned and improved."
	},
	{
		"id": 249,
		"name": "Hide and Seek",
		"recommended": true,
		"season": 8,
		"airdate": "2017-02-01",
		"summary": "While exploring some futuristic ruins, Susan sees glimpses of a familiar girl."
	},
	{
		"id": 250,
		"name": "Min & Marty",
		"recommended": true,
		"season": 8,
		"airdate": "2017-02-01",
		"summary": "An unexpected revelation from Susan leads Finn closer to answers about his past."
	},
	{
		"id": 251,
		"name": "Helpers",
		"recommended": true,
		"season": 8,
		"airdate": "2017-02-02",
		"summary": "Finn and his friends journey to a last refuge called Founders Island."
	},
	{
		"id": 252,
		"name": "The Light Cloud",
		"recommended": true,
		"season": 8,
		"airdate": "2017-02-02",
		"summary": "Finn confronts the power behind Founders Island, but will he ever return home to Ooo?."
	},
	{
		"id": 253,
		"name": "The Orb",
		"recommended": true,
		"season": 8,
		"airdate": "2017-04-21",
		"summary": "Finn, Jake and BMO's dreams fall under the influence of a mysterious orb."
	},
	{
		"id": 254,
		"name": "Skyhooks",
		"recommended": true,
		"season": 8,
		"airdate": "2017-04-24",
		"summary": "When they return to Ooo, Finn and Jake discover that there have been radical changes in their absence."
	},
	{
		"id": 255,
		"name": "Bespoken For",
		"season": 8,
		"airdate": "2017-04-24",
		"summary": "Ice King weaves a tale filled with drama, romance and men's fashion."
	},
	{
		"id": 256,
		"name": "Winter Light",
		"recommended": true,
		"season": 8,
		"airdate": "2017-04-25",
		"summary": "Finn, Jake and Ice King travel to the new Ice Kingdom to confront the person responsible for the changes."
	},
	{
		"id": 257,
		"name": "Cloudy",
		"recommended": true,
		"season": 8,
		"airdate": "2017-04-25",
		"summary": "Finn and Jake must escape exile in an endless sky before they can restore Ooo."
	},
	{
		"id": 258,
		"name": "Slime Central",
		"recommended": true,
		"season": 8,
		"airdate": "2017-04-26",
		"summary": "When Finn and Jake infiltrate the new Slime Kingdom, they become embroiled in a very heated skate battle."
	},
	{
		"id": 259,
		"name": "Happy Warrior",
		"recommended": true,
		"season": 8,
		"airdate": "2017-04-26",
		"summary": "Finn and his friends fight through a more brutal Fire Kingdom to find Flame Princess."
	},
	{
		"id": 260,
		"name": "Hero Heart",
		"recommended": true,
		"season": 8,
		"airdate": "2017-04-27",
		"summary": "A full-scale war breaks out between two kingdoms, and Ooo's most unlikely hero must put an end to the fighting."
	},
	{
		"id": 261,
		"name": "Skyhooks II",
		"recommended": true,
		"season": 8,
		"airdate": "2017-04-27",
		"summary": "Finn and Lumpy Space Princess work together to unlock one of Ooo's greatest secrets before time runs out."
	},
	{
		"id": 262,
		"name": "Abstract",
		"recommended": true,
		"season": 8,
		"airdate": "2017-07-17",
		"summary": "As Jake goes through some personal changes, he's haunted by a sinister dream encounter with his brother Jermaine."
	},
	{
		"id": 263,
		"name": "Ketchup",
		"recommended": true,
		"season": 8,
		"airdate": "2017-07-18",
		"summary": "BMO and Marceline swap stories about their recent adventures."
	},
	{
		"id": 264,
		"name": "Fionna and Cake and Fionna",
		"season": 8,
		"airdate": "2017-07-19",
		"summary": "An unexpected critic shows up at Ice King's latest Fionna and Cake book reading."
	},
	{
		"id": 265,
		"name": "Whispers",
		"recommended": true,
		"season": 8,
		"airdate": "2017-07-20",
		"summary": "While safeguarding a frightened Sweet P, Finn is led into a confrontation with an old foe."
	},
	{
		"id": 266,
		"name": "Three Buckets",
		"recommended": true,
		"season": 8,
		"airdate": "2017-07-21",
		"summary": "Finn and Fern's carefree visit to some old ruins turns disastrous."
	},
	{
		"id": 267,
		"name": "The Wild Hunt",
		"recommended": true,
		"season": 9,
		"airdate": "2017-09-17",
		"summary": "A fierce creature is terrorizing the Candy Kingdom but before Finn can slay the beast, he must first overcome a guilty conscience."
	},
	{
		"id": 268,
		"name": "Always BMO Closing",
		"recommended": true,
		"season": 9,
		"airdate": "2017-09-17",
		"summary": "BMO and Ice King hit the road as door-to-door salesmen and stumble upon an irresistible opportunity."
	},
	{
		"id": 269,
		"name": "Son of Rap Bear",
		"season": 9,
		"airdate": "2017-09-17",
		"summary": "When Flame Princess is coaxed into a high stakes battle against the indomitable Son of Rap Bear, Finn must help her search for a new strategy."
	},
	{
		"id": 270,
		"name": "Bonnibel Bubblegum",
		"recommended": true,
		"season": 9,
		"airdate": "2017-09-17",
		"summary": "A long lost artifact causes Princess Bubblegum to harken back to the creation of the Candy Kingdom."
	},
	{
		"id": 271,
		"name": "Seventeen",
		"recommended": true,
		"season": 9,
		"airdate": "2017-12-17",
		"summary": "A mysterious knight crashes Finn's birthday bash and presents him with a dangerous gift."
	},
	{
		"id": 272,
		"name": "Ring of Fire",
		"season": 9,
		"airdate": "2017-12-17",
		"summary": "When an old flame comes calling on urgent business, Tree Trunks reconsiders both her wild past and her tranquil present."
	},
	{
		"id": 273,
		"name": "Marcy & Hunson",
		"season": 9,
		"airdate": "2017-12-17",
		"summary": "Hunson Abadeer returns to Ooo to bond with his daughter Marceline, but will he be able to prove he's changed his soul-sucking ways?"
	},
	{
		"id": 274,
		"name": "The First Investigation",
		"recommended": true,
		"season": 9,
		"airdate": "2017-12-17",
		"summary": "Finn and Jake are tasked with investigating reports of a haunting at Joshua and Margaret's old office."
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/episodes.json
// module id = 145
// module chunks = 0